import React, { useState, useEffect } from 'react';
import logoLettre from '../../../resources/images/logo-lettre.svg';
import { useHistory } from 'react-router';
import useWelcomeCtr from '../../../controller/use-welcom-ctr';
import { useSelector, useDispatch } from 'react-redux';
import { rootState } from '../../../redux/reducers';
import { logout } from '../../../redux/actions/acounts-action';
import { fileUrl } from '../../../utils';
import { useDataContext } from '../../../context/index';
import BlockNotif from '../../widget/block-notif/index';
import { BlockMessage } from '../bloc-message-notif';

export default function Header(props: any) {
  console.log(props);
  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };
  const { stopEvtSource } = useDataContext();

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const userState = useSelector((state: rootState) => state.userReducer);
  const { getStarted, goLogin } = useWelcomeCtr();
  const history = useHistory();
  const dispatch = useDispatch();

  const showProfil = () => {
    history.push('/profil');
  };

  const goToSettings = () => {
    history.push('/settings');
  };

  const cb = (params: boolean) => {
    if (params) {
      history.push('/signin');
    }
  };
  const logOut = () => {
    stopEvtSource();
    dispatch(logout(cb));
  };

  const goToCompanyPage = () => {
    if (
      userState &&
      userState.isvInCompanyPage &&
      userState.isvInCompanyPage.company_page.completed
    ) {
      history.push('/company/profil');
    } else {
      history.push('/company/create');
    }
  };

  const goToCommunityHome = () => {
    history.push('/community/home');
  };
  const goToDiscussionCategories = () => {
    history.push('/community/discussions-categories');
  };
  const goToArticleCategoriy = () => {
    history.push('/community/article-category/0/0');
  };
  const goToClassifiedAds = () => {
    history.push('/classified-ads/home');
  };

  const goDashBoard = () => {
    history.push('/dashboard');
  };

  const showDiscussion = () => {
    history.push('/contact/discussion');
  };

  return (
    <div className="principalMenu">
      <div className="container mx-auto">
        <div className="leftItemHeader">
          <div className="logoHeader">
            <img
              src={logoLettre}
              alt=""
              style={{ cursor: "pointer" }}
              onClick={() => history.push("/")}
            />
          </div>
          <div className="menuDynamic tl">
            <div className="item">
              <a
                href="javascript:;"
                className="parent linkHeader"
                onClick={(e) => {
                  e.preventDefault();
                  goToCommunityHome();
                }}
              >
                Community
              </a>
              <div className="submenu">
                <div className="title">
                  <div className="container mx-auto">
                    <span
                      onClick={() => {
                        goToCommunityHome();
                      }}
                    >
                      Community
                    </span>
                    Join a global community for software publishers (ISVs).
                  </div>
                </div>
                <div className="container mx-auto">
                  <a
                    className="linkHeader"
                    href="javascript:;"
                    onClick={() => goToDiscussionCategories()}
                  >
                    <span className="name">Forum discussions</span>
                    <p>
                      Discuss the business challenges of your software company
                      with peers and industry experts.
                    </p>
                  </a>
                  <a
                    className="linkHeader"
                    href="javascript:;"
                    onClick={() => goToArticleCategoriy()}
                  >
                    <span className="name">Articles</span>
                    <p>
                      Share your expertise and insights to help software publishers
                      with high-value content.
                    </p>
                  </a>
                </div>
              </div>
            </div>
            <div className="item">
              <a href="javascript:;" className="linkHeader parent">
                Marketplace
                {/*<span className="puissance">Beta</span>*/}
              </a>
              <div className="submenu">
                <div className="title">
                  <div className="container mx-auto">
                    <span onClick={() => goToClassifiedAds()}>Marketplace</span>
                    Identify partnership opportunities with resellers, investors
                    and other professionals working in the software industry.
                  </div>
                </div>
                <div className="container mx-auto">
                  <a
                    href="javascript:;"
                    onClick={() => goToClassifiedAds()}
                    className="linkSubMenu linkHeader"
                  >
                    <span className="name">Marketplace</span>
                    <p>
                      Post an advertisement to find strategic business partners
                      to grow your software business.
                    </p>
                  </a>
                  {/*<a href="javascript:;" className="linkSubMenu linkHeader">
                    <span className="name">The beta version is live!</span>
                    <p>
                      Contribute to Devinsider community to help us improve our
                      Classified ads. <br />
                      <span
                        className="links_beta"
                        onClick={() => goToCommunityHome()}
                      >
                        Go to the community{" "}
                        <span className="petit">&gt;&gt;</span>
                      </span>
                    </p>
                    </a>*/}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="rightItemHeader">
          {userState && userState.enable ? (
            <div className="menuDynamic tr">
              <div className="item">
                <a
                  href="javascript:;"
                  className="linkHeader"
                  onClick={(e: any) => {
                    e?.preventDefault();
                    goDashBoard();
                  }}
                >
                  <span className="icon-home"></span>
                  <span className="mobile">Home</span>
                </a>
              </div>
              <div
                className="item"
                onClick={(e: any) => {
                  showDiscussion();
                }}
              >
                <BlockMessage unread={props.unread} />
              </div>
              <BlockNotif />
              <div className="item">
                <a href="javascript:;" className="parent linkHeader">
                  <div className={`profilImg`}>
                    <img
                      alt="Profile"
                      src={`${fileUrl(userState.file_name)}`}
                    />
                  </div>
                  <span className="mobile">My account</span>
                </a>
                <div className="submenu">
                  <a href="javascript:;" onClick={() => showProfil()}>
                    Profile
                  </a>
                  <a href="javascript:;" onClick={() => goToSettings()}>
                    Account settings
                  </a>
                  <a href="javascript:;" onClick={() => logOut()}>
                    Sign out
                  </a>
                </div>
              </div>
            </div>
          ) : (
            <div className="menuDynamic tr notConnected">
              <div className="item">
                <a
                  href="javascript:;"
                  className="signinHeader"
                  onClick={() => goLogin()}
                >
                  Sign in
                </a>
              </div>
              <div className="item">
                <a
                  href="javascript:;"
                  className="getstartedHeader"
                  onClick={() => getStarted()}
                >
                  Get started
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
